/* eslint-disable */
import 'isomorphic-fetch';
import { Api } from './API2';

class ApiCustom extends Api {

    postB2BCustomerSecurityCertificatePDFActionCustom(
        companyId,
        certificateId,
        parameters = {},
    ) {
        let path = '/b2b/{companyId}/security-certificates/{certificateId}/upload';
        let body = {};
        let queryParameters = {};
        let headers = new Headers();
        let form = {};

        headers = this.appendAuthHeaders(headers);
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');

        path = path.replace('{companyId}', companyId);

        path = path.replace('{certificateId}', certificateId);

        if (typeof parameters['body'] !== 'undefined') {
            form = parameters['body'];
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        return this.request(
            'POST',
            `${this.baseUrl}${path}`,
            body,
            headers,
            queryParameters,
            form,
        );
    }
}

export default new ApiCustom();
export { ApiCustom };


// WEBPACK FOOTER //
// ./src/APICustom.js